import { Filter } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgFilter = mkIcon(Filter);